import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const useRouteState = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { authenticated, loading } = useAuth();

  // Save current route to localStorage when it changes
  useEffect(() => {
    if (authenticated) {
      localStorage.setItem('lastRoute', location.pathname + location.search);
    }
  }, [location, authenticated]);

  // Restore last route on component mount
  useEffect(() => {
    const lastRoute = localStorage.getItem('lastRoute');
    
    // Only restore route if:
    // 1. We have a saved route
    // 2. We're currently on the home page
    // 3. Authentication check is complete (not loading)
    // 4. User is authenticated
    if (lastRoute && location.pathname === '/' && !loading && authenticated) {
      navigate(lastRoute, { replace: true });
    }
    
    // If user is not authenticated, clear saved route
    if (!loading && !authenticated) {
      localStorage.removeItem('lastRoute');
    }
  }, [loading, authenticated]);

  return null;
};

export default useRouteState; 